
import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ProjectClusterDto extends EpimsBaseEntityDto {

                ProjectClusterId: string;
                ClusterId: string;
  @IsNotEmpty() ClusterName: string;
  @IsNotEmpty() ProjectId: string;

}
